// pages/.../Branches.jsx
import React, { useState } from 'react';
import { FiPlusCircle } from 'react-icons/fi';
import PortalDataTable from "../../../components/PortalDataTable";
import { Modal } from "../../../components";
import { branchColumns } from "../../../utils";
import { useGetBranchesPaged } from '../../../hooks/branches/useGet';
import CreateBranch from '../../../forms/create/CreateBranch';
import NetworkError from '../../../components/NetworkError';

const Branches = () => {
  // pagination (HOOKS FIRST)
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const { data: pageData, isLoading, isError, error } = useGetBranchesPaged(page, pageSize);

  const rows = pageData?.items ?? [];
  const currentPage = pageData?.pageNumber ?? page;
  const totalPages =
    typeof pageData?.totalPages === 'number'
      ? pageData.totalPages
      : (pageData?.hasNext ? currentPage + 1 : currentPage);
  const hasPrevious = pageData?.hasPrevious ?? currentPage > 1;
  const hasNext = pageData?.hasNext ?? (rows.length >= pageSize);

  // <- NOT a hook; just a derived value (no lint warning)
  const countLabel =
    typeof pageData?.totalCount === 'number' ? pageData.totalCount : rows.length;

  const [toggleModal, setToggleModal] = useState(false);
  const handleModalToggle = () => setToggleModal(prev => !prev);

  // EARLY RETURNS AFTER ALL HOOKS/DERIVED VALUES
  if (isError && error?.code === 'ERR_NETWORK') return <NetworkError error={error} />;
  if (isError) return <span>Oops something happened....</span>;

  const next = () => hasNext && setPage(p => p + 1);
  const prev = () => hasPrevious && setPage(p => Math.max(1, p - 1));
  const gotoPage = (p) => setPage(Math.max(1, p));
  const changePageSize = (sz) => { setPageSize(sz); setPage(1); };

  return (
    <div className="w-full flex flex-col px-10">
      <div className="branch_header">
        <div className="branch_header_title_group">
          <div className="branch_header_title_main">Branches</div>
          {!isLoading && (
            <div className="branch_header_title_sub">
              {countLabel === 0 ? 'No ' : countLabel} branches
            </div>
          )}
        </div>
        <div className="branch_header_buttons_group">
          <div onClick={handleModalToggle} className="branch_header_buttons_right bg-[#0E86D4]">
            <FiPlusCircle style={{ marginRight: 10 }} />
            New Branch
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2 mb-2">
        <span className="text-sm text-gray-600">Page size:</span>
        <select
          className="border rounded px-2 py-1 text-sm"
          value={pageSize}
          onChange={(e) => changePageSize(Number(e.target.value))}
        >
          {[10, 20, 50, 100].map((sz) => (
            <option key={sz} value={sz}>{sz}</option>
          ))}
        </select>
      </div>

      <Modal
        title="Create Branch"
        form={<CreateBranch onClose={handleModalToggle} />}
        toggleModal={toggleModal}
        handleToggle={handleModalToggle}
      />

      <PortalDataTable
        cols={branchColumns}
        loading={isLoading}
        rows={rows}
        currentPage={currentPage}
        totalPages={totalPages}
        hasPrevious={hasPrevious}
        hasNext={hasNext}
        next={next}
        previous={prev}             // rename to `previous` if your table expects that
        onPageChange={gotoPage}
      />
    </div>
  );
};

export default Branches;
